module.exports = __webpack_public_path__ + "static/img/team-img-bg-blue.597061f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-img-bg-blue.png
// module id = Ktb/
// module chunks = 0